var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pt-4",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-center",attrs:{"id":"chart-container"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }